<template>
    <el-scrollbar :native="false" style="height: 100%;">
        <el-main>
            <el-form :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="100px" ref="ruleForm" style="width: 500px;margin: 0 auto;">

                <el-form-item label="发票号" prop="invoiceId">
                    <el-input disabled v-model="ruleForm.invoiceId"></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="invoiceMoney">
                    <el-input disabled v-model="ruleForm.invoiceMoney"></el-input>
                </el-form-item>
                <el-form-item label="抬头类型" prop="invoiceType">
                    <el-radio-group v-model="ruleForm.invoiceType" @change="invoiceTypeChange">
                        <el-radio :label="1">单位</el-radio>
                        <el-radio :label="2">个人</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发票类型" prop="invoiceExclusiveType">
                    <el-radio-group disabled v-model="ruleForm.invoiceExclusiveType">
                        <el-radio :label="0">普通发票</el-radio>
                        <el-radio :label="1">专用发票</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发票抬头" prop="invoiceTitle">
                    <el-input v-model="ruleForm.invoiceTitle" maxlength="50" show-word-limit/>
                </el-form-item>
                <el-form-item label="税号" prop="invoiceDutyParagraph">
                    <el-input v-model="ruleForm.invoiceDutyParagraph" @input="convertToUpper"/>
                </el-form-item>
                <el-form-item label="发票内容" prop="invoiceContent">
                    <el-input disabled value="咨询服务费"></el-input>
                </el-form-item>
                <el-form-item label="开票状态" prop="invoiceMakeOutStatus">
                    <el-select placeholder="请选择" v-model="ruleForm.invoiceMakeOutStatus">
                        <el-option :value="0" label="开票中"></el-option>
                        <el-option :value="1" label="已开"></el-option>
                        <el-option :value="2" label="完成"></el-option>
                        <el-option :value="3" label="重开"></el-option>
                        <el-option :value="4" label="已废弃"></el-option>
                        <el-option :value="5" label="未支付"></el-option>
                        <el-option :value="9" label="退票中"></el-option>
                        <el-option :value="10" label="已退票"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户行及账户">
                    <el-input v-model="ruleForm.invoiceBankAccount" placeholder="请输入开户行及账户"/>
                </el-form-item>
                <el-form-item label="地址和电话">
                    <el-input v-model="ruleForm.invoiceAddressPhone" placeholder="请输入地址和电话"/>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="invoiceEmail">
                    <el-input v-model="ruleForm.invoiceEmail" placeholder="请输入电子邮箱"/>
                </el-form-item>
                <el-form-item label="备注" prop="invoiceRemark">
                    <el-input type="textarea" v-model="ruleForm.invoiceRemark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submitForm('ruleForm')" type="primary">保存</el-button>
<!--                    <el-button @click="resetForm('ruleForm')">重置</el-button>-->
                </el-form-item>
            </el-form>
        </el-main>
    </el-scrollbar>
</template>

<script>
    export default {
        name: "backInvoiceTitleEdit",
        data() {
            return {
                invoiceId:'',
                ruleForm: {
                    invoiceType:1,//抬头类型 1单位、2个人
                    invoiceExclusiveType:0,//发票类型 0普通发票、1专用发票,
                    invoiceTitle:'',
                    invoiceDutyParagraph:'',//税号
                    invoiceMoney:0,
                    invoiceContent: "咨询服务费",
                    invoiceMakeOutStatus:0,
                    invoiceBankAccount: '',
                    invoiceAddressPhone: '',
                    invoiceEmail: '',
                    invoiceRemark:''
                },
                rules: {
                    invoiceType: [
                        { required: true, message: '请选择发票抬头类型', trigger: 'change' }
                    ],
                    invoiceTitle: [
                        { required: true, message: '请输入发票抬头', trigger: 'change' },
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    invoiceDutyParagraph: [
                        { required: true, message: '请输入发票税号', trigger: 'blur' },
                        { validator: (rule, value, callback) => {
                          if (this.ruleForm.invoiceType === 2 && !value) {
                            return callback();
                          }
                          var regex = /^[a-zA-Z0-9]{15}(?:[a-zA-Z0-9]{3})?$/;
                          if(regex.test(value)){
                            callback();
                          }else{
                            callback(new Error('只能输入15或18位的字母和数字'));
                          }
                        }, trigger: 'change'}
                    ],
                    invoiceMoney: [
                        { required: true, message: '请输入发票金额', trigger: 'change' }
                    ],
                    invoiceContent: [
                        { required: true, message: '请输入发票内容', trigger: 'change' }
                    ],
                    invoiceEmail: [
                        { required: true, message: '请输入电子邮箱', trigger: 'change'},
                        { validator: (rule, value, callback) => {
                            var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if(regex.test(value)){
                                callback();
                            }else{
                                callback(new Error('邮箱格式错误'));
                            }
                        }, trigger: 'change'}
                    ]
                }
            };
        },
        mounted() {
            this.invoiceId = this.$route.query.id;
            this.$request.myInvoiceDetail({
                id:this.$route.query.id
            }).then(res=>{
                console.log(res);
                if(res.status==200){
                  this.ruleForm = res.data;
                  this.ruleForm.invoiceMoney /= 100
                  this.rules.invoiceDutyParagraph[0].required = this.ruleForm.invoiceType === 1
                }else {
                    this.requestError(res.status,res.message);
                }
            },err=>{
                console.log(err);
                this.requestFail(err);
            });
        },
        methods: {
          invoiceTypeChange() {
            this.rules.invoiceDutyParagraph[0].required = this.ruleForm.invoiceType === 1
          },
            convertToUpper(){
                this.ruleForm.invoiceDutyParagraph = this.ruleForm.invoiceDutyParagraph.toUpperCase();
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log('submit!');
                        this.$request.editInvoice({
                            ...this.ruleForm
                        }).then(res=>{
                            console.log(res);
                            if(res.status==200){
                                this.$message({
                                    type: 'success',
                                    dangerouslyUseHTMLString:true,
                                    message: `操作成功！`
                                });
                            }else {
                                this.requestError(res.status,res.message);
                            }
                        },err=>{
                            console.log(err);
                            this.requestFail(err);
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>

</style>